import * as validator from 'validator';
import isEmpty from 'lodash/isEmpty';
import isUndefined from 'lodash/isUndefined';
import IntlMessages from 'util/IntlMessages';
import React from 'react'
export default function validateInput(data,MEmail) {
  let errors = {};
  const uppercaseRegExp   = /(?=.*?[A-Z])/;
  const lowercaseRegExp   = /(?=.*?[a-z])/;
  const digitsRegExp      = /(?=.*?[0-9])/;
  const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
  const minLengthRegExp   = /.{8,}/;
  const passwordLength =      isUndefined(data.password)?0:data.password.length;
  const uppercasePassword =   isUndefined(data.password)?false:uppercaseRegExp.test(data.password);
  const lowercasePassword =   isUndefined(data.password)?false:lowercaseRegExp.test(data.password);
  const digitsPassword =      isUndefined(data.password)?false:digitsRegExp.test(data.password);
  const minLengthPassword =   isUndefined(data.password)?false:minLengthRegExp.test(data.password);
  const specialCharPassword =   isUndefined(data.password)?false:specialCharRegExp.test(data.password);

  /*
  if (validator.isEmpty(data.Orgnr)) {
    errors={
        ...errors,
        Orgnr:'This field is required'
    }
  }*/
  if (passwordLength === 0 || !minLengthPassword || !uppercasePassword || !lowercasePassword || !digitsPassword
    || !specialCharPassword) {
    errors.password = <IntlMessages id="Account.New.Password.Error.length" />;
  }
  if (!validator.isEmail(data.email)) {
    errors={
        ...errors,
        email:'This field is required'
    }
  }
  if (data.email.toLowerCase() !== MEmail.toLowerCase()) {
    errors={
        ...errors,
        email:'Epost fel'
    }
  }
  return {
    errors:errors,
    isValid: isEmpty(errors)
  };
}